import React from 'react';
import { AdminCrudShell } from '@/components/admin/AdminCrudShell';
import { Badge } from '@/components/ui/badge';

const TYPE_OPTS = [
  { value: 'internal_cdn', label: 'Internal CDN' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'vimeo', label: 'Vimeo' },
  { value: 'dailymotion', label: 'Dailymotion' },
  { value: 'bunny', label: 'Bunny Stream / CDN' },
  { value: 'other', label: 'Otro' },
];
const STATUS_OPTS = [
  { value: 'inactive', label: 'Inactivo' },
  { value: 'active', label: 'Activo' },
];

export default function AdminVideoProviders() {
  return (
    <AdminCrudShell
      title="Proveedores de vídeo"
      subtitle="CDN/embed providers. Configurables a futuro (Mux, CloudFront, YouTube, Vimeo…)."
      entity="video-providers"
      testIdPrefix="admin-video-providers"
      addLabel="Nuevo provider"
      searchPlaceholder=""
      initialForm={{
        name: '', provider_type: 'other', status: 'inactive',
        api_key_reference: '', supports_signed_urls: false, supports_cdn: false,
      }}
      columns={[
        { key: 'name', label: 'Nombre' },
        { key: 'provider_type', label: 'Tipo', render: (r) => <Badge variant="secondary" className="uppercase tracking-wider text-[10px]">{r.provider_type}</Badge> },
        { key: 'status', label: 'Estado', render: (r) => <Badge className={`text-[10px] uppercase ${r.status === 'active' ? 'bg-[var(--ns-gold)]/20 text-[var(--ns-gold-700)]' : 'bg-[var(--ns-bg-2)] text-[var(--ns-text-muted)]'}`}>{r.status}</Badge> },
      ]}
      formFields={[
        { name: 'name', label: 'Nombre', required: true, lowercase: false },
        { name: 'provider_type', label: 'Tipo', type: 'select', required: true, options: TYPE_OPTS },
        { name: 'api_key_reference', label: 'Referencia de API key (env var)', placeholder: 'MUX_TOKEN_ID', lowercase: false, hint: 'Solo el nombre de la variable de entorno; nunca pegues la clave.' },
        { name: 'status', label: 'Estado', type: 'select', required: true, options: STATUS_OPTS },
      ]}
    />
  );
}
